const cards = [
  {
    title: '红桃视频本月精选 TOP10',
    desc: '精选红桃视频频道本月最受欢迎的数字颜色系列作品，从热门连载到隐藏神作一应俱全。',
    tag: '红桃视频',
    img: 'https://readdy.ai/api/search-image?query=Warm%20crimson%20and%20rose%20abstract%20gradient%20with%20soft%20organic%20curves%20and%20gentle%20light%20highlights%2C%20cinematic%20romantic%20mood%2C%20luxurious%20red%20tones%20on%20dark%20background&width=640&height=400&seq=card-heart&orientation=landscape'
  },
  {
    title: '小蓝视频经典修复完全指南',
    desc: '小蓝视频频道所有经典作品4K修复进度一览，画质提升对比与最佳观看顺序推荐。',
    tag: '小蓝视频',
    img: 'https://readdy.ai/api/search-image?query=Moody%20teal%20and%20navy%20abstract%20gradient%20with%20flowing%20wave%20patterns%2C%20cinematic%20deep%20sea%20atmosphere%2C%20luxurious%20blue%20tones%20on%20dark%20minimalist%20surface&width=640&height=400&seq=card-blue&orientation=landscape'
  },
  {
    title: '黑桃视频深夜剧场排期表',
    desc: '黑桃视频频道本周深夜剧场全排期，悬疑惊悚文艺片单提前锁定不迷路。',
    tag: '黑桃视频',
    img: 'https://readdy.ai/api/search-image?query=Dark%20charcoal%20and%20onyx%20abstract%20with%20sharp%20angular%20geometric%20cuts%20and%20subtle%20crimson%20glow%2C%20dramatic%20noir%20atmosphere%2C%20luxurious%20mysterious%20composition&width=640&height=400&seq=card-spade&orientation=landscape'
  },
  {
    title: '91视频都市专题深度解读',
    desc: '91视频风格都市专题系列深度解析，从当代情感观察到人际关系洞察的全面覆盖。',
    tag: '91视频',
    img: 'https://readdy.ai/api/search-image?query=Warm%20amber%20and%20copper%20abstract%20gradient%20with%20glowing%20rectangular%20blocks%20and%20soft%20urban%20light%2C%20night%20city%20cinematic%20vibe%2C%20luxurious%20golden%20hour%20tones&width=640&height=400&seq=card-91&orientation=landscape'
  },
  {
    title: '97视频4K片源清单速览',
    desc: '97视频频道本周新增4K高清片源完整清单，画质党必备的收藏指南，触手可及。',
    tag: '97视频',
    img: 'https://readdy.ai/api/search-image?query=Rich%20burgundy%20and%20violet%20abstract%20gradient%20with%20soft%20light%20prism%20rays%2C%20cinematic%20ultra%20premium%20atmosphere%2C%20luxurious%20deep%20color%20tones%20on%20dark%20surface&width=640&height=400&seq=card-97&orientation=landscape'
  },
  {
    title: '久久视频周末特辑预告',
    desc: '久久视频周末限免特辑内容提前揭秘，精心编排的数字颜色系列观影盛宴即将开启。',
    tag: '久久视频',
    img: 'https://readdy.ai/api/search-image?query=Soft%20plum%20and%20mauve%20abstract%20gradient%20with%20overlapping%20translucent%20circles%2C%20elegant%20cinematic%20atmosphere%2C%20warm%20purple%20undertones%20on%20dark%20minimalist%20background&width=640&height=400&seq=card-99&orientation=landscape'
  },
  {
    title: '数字颜色系列新手上路指南',
    desc: '初次接触数字颜色系列？从频道介绍到观看路径的完整新手引导手册，三步快速上手。',
    tag: '新手必看',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20guide%20map%20concept%20with%20warm%20amber%20and%20crimson%20connection%20lines%20on%20dark%20surface%2C%20minimalist%20navigation%20aesthetic%2C%20luxurious%20tech%20atmosphere&width=640&height=400&seq=card-guide&orientation=landscape'
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="relative py-14 md:py-20 bg-background-900/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm text-accent-400 font-medium tracking-wider uppercase mb-2">Discover</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">发现更多</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">妖精视频数字颜色系列频道深度内容卡片</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group bg-background-800/40 rounded-lg overflow-hidden border border-background-700/30 hover:border-primary-500/20 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-36 md:h-40 bg-background-700/40 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-800/80 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2 py-1 rounded-full bg-accent-500/80 backdrop-blur-sm text-background-950 font-medium whitespace-nowrap">{card.tag}</span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-medium text-foreground-200 group-hover:text-foreground-50 transition-colors duration-200 line-clamp-2">{card.title}</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}